export default function v42(website) {
  return {
    ...website,
    eventVersion: 42,
    layoutItems: {
      ...website.layoutItems,
      CventFooterSection: {
        ...website.layoutItems.CventFooterSection,
        config: {
          ...website.layoutItems.CventFooterSection.config,
          cventPrivacyPolicy: {
            visible: true,
            text: '_cventFooter_privacyPolicy__resx'
          },
          plannerPrivacyPolicy: {
            visible: false,
            url: '',
            text: 'EventWidgets_EventFooter_PlannerPrivacyPolicyText__resx'
          }
        }
      }
    }
  };
}
